module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header"
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [(_vm.isLogin) ? _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#header_collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', [_vm._v("メニュー")])]) : _vm._e(), _c('router-link', {
    staticClass: "navbar-bland",
    attrs: {
      "to": "/"
    }
  }, [_c('h1', [_vm._v("ファムケア報告書")])])], 1), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "header_collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "help-modal-btn",
      "data-toggle": "modal",
      "data-target": "#help-modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Help')))])])]), (_vm.isLogin && _vm.canManage) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/shops"
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Change Shop')))])])], 1) : _vm._e(), (_vm.isLogin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentUserName))]), (_vm.currentShopName !== null) ? _c('span', [_vm._v("(" + _vm._s(_vm.currentShopName) + ")")]) : _vm._e()])], 1) : _vm._e(), (_vm.isLogin) ? _c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Logout')))])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1f6d94c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-header.pug
// module id = 411
// module chunks = 1